import { render } from "./ExchangeChat.vue?vue&type=template&id=6ffb5d08"
import script from "./ExchangeChat.vue?vue&type=script&lang=js"
export * from "./ExchangeChat.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__